import React from 'react';

import {BulkActionResult} from 'src/components/bulk-tool';

import {UnassignProductUserEntitlementsResultModal} from './unassign-product-user-entitlements.result.modal';
import {
    clearResult,
    selectUnassignProductUserEntitlementsBulkUuid,
    selectUnassignProductUserEntitlementsShown,
    selectUnassignProductUserEntitlementsTask,
} from './unassign-product-user-entitlements.slice';


export const UnassignProductUserEntitlementsResult = () => (
    <BulkActionResult
        actionIdSelector={selectUnassignProductUserEntitlementsBulkUuid}
        actionTaskSelector={selectUnassignProductUserEntitlementsTask}
        actionShownSelector={selectUnassignProductUserEntitlementsShown}
        clearResult={clearResult}>
        {({id, onClose}) => (
            <UnassignProductUserEntitlementsResultModal id={id} onClose={onClose}/>
        )}
    </BulkActionResult>
);
